<template>
    <products-list @onFetchRequested="onFetchRequested"
                   @onHistoryPushed="onHistoryPushed"
                   :searchResponse="searchResponse"
                   :languageId="languageId"
                   :searchTerm="searchTerm"></products-list>
</template>

<script lang="ts" src="./SearchProductsFull.vue.ts"></script>
